import gql from 'graphql-tag';

export const multiBuildingTasksQuery = gql`
  query multiBuildingTasksQuery(
    $channelIds: [UUID!]
    $search: FindTasksSearch
    $pagination: PaginationInput!
    $filter: TaskFilterDTO
  ) {
    multiBuildingTasks(
      channelIds: $channelIds
      search: $search
      pagination: $pagination
      filter: $filter
    ) {
      tasks {
        id
        groupBy {
          name
          id
        }
        dueDate
        repeats {
          label
          value
        }
        estimateTimeToComplete
        assignee {
          _id
          name
        }
        assigneeGroup {
          _id
          name
        }
        notes
        steps
        meterReading
        createdBy
        updatedBy
        completedBy
        equipment {
          id
          location
          name
          category
          floor
          suite
        }
        createdAt
        updatedAt
        completedAt
        isArchived
        location
        actualTimeToComplete
        completeNotes
        status
        nextStatuses
        schedule {
          id
          title
        }
        friendlyID
        userFriendlyID
      }
      pageInfo {
        start
        total
        perPage
      }
    }
  }
`;
